// Position Display Component
// Shows position groups for display purposes

import React from 'react';
import { getAllPositionGroupKeys } from '../../data/positionHierarchy';
import type { Sport } from '../../types';

interface PositionDisplayProps {
  positions: string[]; // Position group keys (e.g., ['RB', 'WR', 'OL'])
  sport: Sport;
  className?: string;
  maxDisplay?: number; // Maximum number of groups to show before truncating
}

export const PositionDisplay: React.FC<PositionDisplayProps> = ({
  positions,
  sport,
  className = '',
  maxDisplay,
}) => {
  if (positions.length === 0) {
    return (
      <span className={`text-gray-400 text-sm ${className}`}>No position groups set</span>
    );
  }

  // Get valid position group keys for this sport
  const validGroups = getAllPositionGroupKeys(sport);
  
  // Filter to only show valid groups (ignore any custom/legacy positions)
  const displayGroups = positions.filter(pos => validGroups.includes(pos));
  const displayCount = maxDisplay ? displayGroups.slice(0, maxDisplay) : displayGroups;
  const remaining = maxDisplay ? displayGroups.length - maxDisplay : 0;

  return (
    <div className={`flex flex-wrap gap-0.5 ${className}`}>
      {displayCount.map((group) => (
        <span
          key={group}
          className="px-1.5 py-0.5 bg-primary bg-opacity-10 text-primary rounded text-[10px] font-medium"
        >
          {group}
        </span>
      ))}
      {remaining > 0 && (
        <span className="px-1.5 py-0.5 text-gray-500 text-[10px]">
          +{remaining}
        </span>
      )}
    </div>
  );
};

